module.exports = __webpack_public_path__ + "img/assistantAccount-home-warp3-img2.ebe98524.png";